import PageRoute from './PageRoutes';

const AuthCheck = (props) => {
  if (!localStorage.getItem("token")) {
    // User is not logged in. Redirect back to login
    props.history.push(PageRoute.login);
  }
}

export default AuthCheck